import { render, staticRenderFns } from "./refund_detail.vue?vue&type=template&id=4359536b&scoped=true&"
import script from "./refund_detail.vue?vue&type=script&lang=js&"
export * from "./refund_detail.vue?vue&type=script&lang=js&"
import style0 from "./refund_detail.vue?vue&type=style&index=0&id=4359536b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359536b",
  null
  
)

export default component.exports